<template>
    <div class="autocomplete">
        <label>
            <input type="text" v-model="search" @click="showOptions" />            
            <i class="mdi mdi-menu-up" v-if="showing_options"></i>
            <i class="mdi mdi-menu-down" v-else></i>
        </label>
        <div class="autocomplete-options" v-if="showing_options">
            <ul>
                <li :class="{selectd: option.value == value}" v-for="option in options" :key="option.value"
                    @click="evt => setValue(option)">{{ option.text }}</li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    props: ['value', 'options'],
    data() {
        return {
            Search: '',
            show_options: false
        }
    },
    methods: {
        setValue(option) {
            this.$emit('input', `${option.value}`)
            //this.Search = ''
            this.Search = option.text
            //this.show_options = false
            
        },
        showOptions() {
            
            this.show_options = !this.show_options
        }
    },
    computed: {
        search: {
            get() {                
                if (this.Search != '') {
                    
                    return this.Search
                } 

               
               return this.Search
            }, 
            set(value) {
                
                
                this.Search = value
                
                
            }
        },
        showing_options() {
            let options = this.options || []
            
            return options.length && this.show_options && this.Search != ''
        }
    },
    watch: {
        search(v) {
            
            this.$emit('search', v)
        }
    }
}
</script>
<style scoped lang="less">
.autocomplete {
    position: relative;
    label {
        position: relative;
        i.mdi {
            position: absolute;
            right: 0.5em;
            top: 50%;
            transform: translateY(-50%);
            cursor: pointer;
        }
    }
    .autocomplete-options {
        max-height: 300px;
        overflow-y: auto;
        width: 100%;
        position: absolute;
        background-color: #f3f3f3;
        margin-top: -1em;
        box-shadow: 0 0 5px -2px black;
        ul {
            margin: 0;
            padding: 0;
            list-style: none;
            li {
                padding: 0.5em;
                border-bottom: 1px solid rgba(0,0,0,0.15);
                cursor: pointer;
            }
        }
    }
}
</style>